module.exports = __webpack_public_path__ + "img/兰州大学.6bbfce62.png";